// extracted by mini-css-extract-plugin
export default {"container":"UrlRedirectionStyles_container__rhSwJ"};